/* tslint:disable */

/**
 */
export class Constructors {
    CONSTRUCTOR?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/constructors.ts